<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDeItemResumo from "./LinhaDeItemResumo.vue";
import LinhaDeItemDetalhes from "./LinhaDeItemDetalhes.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "item",
    "tiposDeEquipamento",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:removeItem",
    "update:descartaItem",
    "update:alteraItem",
    "update:adicionaSubitem",
    "update:removeSubitem",
    "update:descartaSubitem",
    "update:alteraSubitem",
]);

//==================================================================//
//======================== Remove Item =============================//
//==================================================================//

const removeItem = (update) =>{

    update.id = props?.item?.id;
    emits('update:removeItem',update);

};

//==================================================================//
//======================= Descarta Item ============================//
//==================================================================//

const descartaItem = (update) =>{

    update.id = props?.item?.id;
    emits('update:descartaItem',update);

};

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) =>{

    update.id = props?.item?.id;
    emits('update:alteraItem',update);

};

//==================================================================//
//====================== Adiciona Subitem ==========================//
//==================================================================//

const adicionaSubitem = (update = {}) =>{

    update.id = props?.item?.id;
    emits('update:adicionaSubitem',update);

};

//==================================================================//
//====================== Remove Subitem ============================//
//==================================================================//

const removeSubitem = (update = {}) =>{

    update = {
        item:{
            id: props?.item?.id,
        },
        subItem: update
    }
    emits('update:removeSubitem',update);

};

//==================================================================//
//===================== Descarta Subitem ===========================//
//==================================================================//

const descartaSubitem = (update = {}) =>{

    update = {
        item:{
            id: props?.item?.id,
        },
        subItem: update
    }
    emits('update:descartaSubitem',update);

};

//==================================================================//
//======================= Altera Subitem ===========================//
//==================================================================//

const alteraSubitem = (update = {}) => {

    update = {
        item:{
            id: props?.item?.id,
        },
        subItem: update
    }
    emits('update:alteraSubitem',update);

};

</script>

<template>

    <div
        class="c-table__row-group"
    >

        <LinhaDeItemResumo
            :dado="props?.dado"
            :item="props?.item"
            :tiposDeEquipamento="props?.tiposDeEquipamento"
            :controlesDesativados="props?.controlesDesativados"
            @update:removeItem="removeItem"
            @update:descartaItem="descartaItem"
            @update:alteraItem="alteraItem"
            @update:adicionaSubitem="adicionaSubitem"
        ></LinhaDeItemResumo>

        <LinhaDeItemDetalhes
            :dado="props?.dado"
            :item="props?.item"
            :controlesDesativados="props?.controlesDesativados"
            @update:removeSubitem="removeSubitem" 
            @update:descartaSubitem="descartaSubitem"
            @update:alteraSubitem="alteraSubitem"
        ></LinhaDeItemDetalhes>

    </div>

</template>

<style scoped>

.c-table__row-group{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>
